import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-ion-common-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnChanges {

  @Input() placeholder = '';
  @Input() fieldValue = '';
  @Input() error = false;
  @Input() id = '';
  @Input() type = '';
  @Input() textError = '';
  @Input() validations = [];
  @Input() maxLength = '';
  @Input() idLabel = '';
  @Input() replaceStrTo: 'document' | 'documentWithSpace' | 'documentWithSpaceBar' | 'nameWantUser'
  | 'name' | 'nameV2' | 'number' | 'date' | 'documentWithSpaceBarCharacter' | 'cpf' | 'nif' | 'tin' | 'phone' | 'email';
  @Input() label = '';
  @Input() labelInput = false;
  @Input() verifyMsgError = false;
  @Output() textChange = new EventEmitter<string>();
  hideStatusResult = true;
  statusResult = '';
  @Input() labelInputText = false;
  @Input() disabled: boolean;
  @Input() isEnablePaste?: boolean = false;

  @ViewChild('inputText') inputText: any;

  masks = {
    nameWantUser: (value: string) => value.replace(/\d/g, '').replace(/[!@#$%&*()-_=+}{\|/?.,]/g, '').replace(/  +/g, ' '),
    name: (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z\s]/g, '').replace(/  +/g, ' '),
    nameV2: (value: string) => value.replace(/[^a-zA-Z\s/ÇçÂâÃãáÁéÉíÍóÓúÚàÀêÊôÔõÕ]/g, '').replace(/  +/g, ' '),
    cep: (value: string) => value.replace(/\D+/g, '').replace(/(\d{5})(\d)/, '$1-$2'),
    cnpj: (value: string) => value.replace(/\D+/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'),
    cpf: (value: string) => value.replace(/\D+/g, '').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})/, '$1-$2'),
    nif: (value: string) => value.replace(/\D/g, '').replace(/(\d{3})(\d)/, '$1.$2').replace(/\.(\d{2})(\d)/, '.$1.$2'),
    date: (value: string) => value.replace(/\D/g, '').replace(/(\d{2})(\d)/, '$1/$2').replace(/(\d{2})(\d)/, '$1/$2'),
    onlyNumberLetter: (value: string) => value.replace(/[^a-z0-9]/gi, '').trim(),
    onlyNumberLetterSpace: (value: string) => value.replace(/[^a-zA-Z0-9\s]/g, '').replace(/  +/g, ' '),
    onlyNumberLetterSpaceBar: (value: string) => value.replace(/[^a-zA-Z0-9\s/]/g, '').replace(/  +/g, ' '),
    onlyNumber: (value: string) => value.replace(/[^0-9]+/gm, ''),
    onlyNumberLetterCharacter: (value: string) => value.replace(/[^a-zA-Z0-9\s/ÇçÂâÃãáÁéÉíÍóÓúÚàÀêÊôÔõÕ]/g, '').replace(/  +/g, ' '),
    tin: (value: string) => value.replace(/[^a-z0-9/+-/]/gi, '')
    .replace('++', '+').replace('--', '-').replace('//', '/')
    .replace('+-', '+').replace('+/', '+')
    .replace('-+', '-').replace('-/', '-')
    .replace('/+', '/').replace('/-', '/')
    .replace('.', '').replace(',', '')
    .replace(/  +/g, ''),
    phone: (value: string) => {
      const val = value.replace(/[^0-9]+/gm, '').replace(/\D+/g, '');
      const firstNumberPhone = val.substring(2, 3);

      if (firstNumberPhone === '9') {
        return val.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        return val.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }
    },
    email: (value: string) => value.replace(/[^a-zA-Z0-9\s/.-_@-]/g, '').replace(/  +/g, ' ')
  };

  constructor(private platform: Platform) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.verifyMsgError?.currentValue) {
      this.setStatusMsgError({ which: 16 });
    }
  }

  keyPressed(e: any) {
    setTimeout(() => {
      this.replaceString(e);
    }, 10);
  }

  replaceString(e: any) {
    this.maskName(e);
    this.maskNameV2(e);
    this.maskNameWantUser(e);
    this.maskDocument(e);
    this.maskDocumentWithSpace(e);
    this.maskDocumentWithSpaceBar(e);
    this.maskNumber(e);
    this.maskCep(e);
    this.maskDate(e);
    this.maskDocumentWithSpaceBarCharacter(e);
    this.maskCnpj(e);
    this.maskCpf(e);
    this.maskNif(e);
    this.maskTin(e);
    this.maskPhone(e);
    this.maskEmail(e);
    this.fieldValue = e.target.value;
    this.textChange.emit(this.fieldValue);
  }

  submitInput(e: any) {
    if (e.which === 13) {
      this.inputText.nativeElement.blur();
      setTimeout(() => this.inputText.nativeElement.focus(), 200);
    }
  }

  setStatusMsgError(e: any) {
    if (e.which !== 13) {
      setTimeout(() => {
        if (this.error && this.fieldValue?.length > 0) {
          this.statusResult = this.textError;
          this.hideStatusResult = false;
          setTimeout(() => {
            this.hideStatusResult = true;
            this.statusResult = '';
          }, 2000);
        }
      }, 1000);
    }
  }

  verifyMsgErrorIosInputText($event: any) {
    if (this.platform.is('ios')) {
      this.setStatusMsgError($event);
    }
  }

  verifyMsgErrorAndroidInputText($event: any) {
    if (this.platform.is('android')) {
      this.setStatusMsgError($event);
    }
  }

  maskCep(e: any) {
    if (this.idLabel === 'address-cep') {
      e.target.value = this.masks.cep(e.target.value);
    }
  }

  maskDate(e: any) {
    if (this.replaceStrTo === 'date') {
      e.target.value = this.masks.date(e.target.value);
    }
  }

  maskName(e: any) {
    if (this.replaceStrTo === 'name') {
      const positionPointer = e.target.selectionStart;
      e.target.value = this.masks.name(e.target.value);
      e.target.selectionEnd = positionPointer;
    }
  }

  maskNameV2(e: any) {
    if (this.replaceStrTo === 'nameV2') {
      const positionPointer = e.target.selectionStart;
      e.target.value = this.masks.nameV2(e.target.value.substring(0, this.maxLength));
      e.target.selectionEnd = positionPointer;
    }
  }

  maskNameWantUser(e: any) {
    if (this.replaceStrTo === 'nameWantUser') {
      const positionPointer = e.target.selectionStart;
      e.target.value = this.masks.nameWantUser(e.target.value);
      e.target.selectionEnd = positionPointer;
    }
  }

  maskDocument(e: any) {
    if (this.replaceStrTo === 'document') {
      e.target.value = this.masks.onlyNumberLetter(e.target.value);
    }
  }

  maskNumber(e: any) {
    if (this.replaceStrTo === 'number') {
      e.target.value = this.masks.onlyNumber(e.target.value);
    }
  }

  maskDocumentWithSpace(e: any) {
    if (this.replaceStrTo === 'documentWithSpace') {
      const positionPointer = e.target.selectionStart;
      e.target.value = this.masks.onlyNumberLetterSpace(e.target.value);
      e.target.selectionEnd = positionPointer;
    }
  }

  maskDocumentWithSpaceBar(e: any) {
    if (this.replaceStrTo === 'documentWithSpaceBar') {
      const positionPointer = e.target.selectionStart;
      e.target.value = this.masks.onlyNumberLetterSpaceBar(e.target.value);
      e.target.selectionEnd = positionPointer;
    }
  }

  maskDocumentWithSpaceBarCharacter(e: any) {
    if (this.replaceStrTo === 'documentWithSpaceBarCharacter') {
      const positionPointer = e.target.selectionStart;
      e.target.value = this.masks.onlyNumberLetterCharacter(e.target.value);
      e.target.selectionEnd = positionPointer;
    }
  }

  maskCnpj(e: any) {
    if (this.idLabel === 'company-cnpj-inf') {
      e.target.value = this.masks.cnpj(e.target.value);
    }
  }

  maskCpf(e: any) {
    if (this.replaceStrTo === 'cpf') {
      e.target.value = this.masks.cpf(e.target.value);
    }
  }

  maskNif(e: any) {
    if (this.replaceStrTo === 'nif') {
      e.target.value = this.masks.nif(e.target.value);
    }
  }

  maskTin(e: any) {
    if (this.replaceStrTo === 'tin') {
      e.target.value = this.masks.tin(e.target.value).toUpperCase();
    }
  }

  maskPhone(e: any) {
    if (this.replaceStrTo === 'phone') {
      e.target.value = this.masks.phone(e.target.value);
    }
  }

  maskEmail(e: any) {
    if (this.replaceStrTo === 'email') {
      e.target.value = this.masks.email(e.target.value);
    }
  }
}
